var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[_vm._v(" 유효시간 "+_vm._s(_vm.filteredTwoDigits(_vm.duration.hours()))+":"+_vm._s(_vm.filteredTwoDigits(_vm.duration.minutes()))+":"+_vm._s(_vm.filteredTwoDigits(_vm.duration.seconds()))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }